import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkStepperModule } from '@angular/cdk/stepper';

import { TabLabel } from './directives/tab-label.directive';
import { McRAIButtonModule } from '../button/button.module';
import { McRAIHorizontalTabs, McRAITab, McRAITabs, McRAIVerticalTabs } from './components/tabs';
import { McRAIPanelModule } from '../panel/panel.module';
import { McRAITabHeader } from './components/tab-header/tab-header.component';
import { McRAIHorizontalInkBar, McRAIVerticalInkBar } from './directives/ink-bar.directive';
import { McRAIIconModule } from '../icon/icon.module';

@NgModule({
  imports: [
    CommonModule,
    CdkStepperModule,
    McRAIPanelModule,
    McRAIButtonModule,
    McRAIIconModule
  ],
  declarations: [
    TabLabel,
    McRAITab,
    McRAITabs,
    McRAIHorizontalTabs,
    McRAITabHeader,
    McRAIHorizontalInkBar,
    McRAIVerticalInkBar,
    McRAIVerticalTabs
  ],
  exports: [
    TabLabel,
    McRAITab,
    McRAITabs,
    McRAIHorizontalTabs,
    McRAITabHeader,
    McRAIVerticalTabs
  ]
})
export class McRAITabsModule { }
